import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { AnimateSharedLayout } from 'framer-motion';

import { Button, Animation } from 'components';
import { DeleteDialogue } from 'features';
import { FaChevronLeft, FaExchangeAlt } from 'react-icons/fa';
import { InflowScreen, OutflowScreen, TriggerScreen } from './screens';
import { TitleInput } from './components';

import { 
    itemContext,
    clientContext
} from 'context';
import { validateWorkflow } from 'utils';
import classes from './Editor.module.css';
import { ClientWorkflow } from 'schema';
import * as actionCreators from 'store/actions';

const Container = styled.div`
    display: grid;
    grid-template-rows: 2rem 1fr;
`

class Editor extends Component {
    constructor(props){
        super(props);
        this.debug = false;
        const workflow = this.props.workflow || new ClientWorkflow({             
            direction: 'INFLOW',
        })
        this.state = {
            section: 'TRIGGER',
            workflow: workflow,
            trigger: workflow['trigger'],
            action: workflow['action'],
            error: { trigger: { ext: {} }, action: { ext: {} } },
            spinner: null
        }

        // Button styles
        this.backStyle = {
            backgroundColor: 'var(--primary-color)',
            boxShadowColor: 'transparent',
        }
    }

    onNext = () => {
        this.setState({...this.state, spinner: 'NEXT'})
        setTimeout(() => {
            // Validation
            let workflow = new ClientWorkflow({
                workflowId: this.state.workflow['workflowId'],
                userId: this.props.uid,
                trigger: this.state.trigger,
                action: this.state.action,
                direction: this.state.workflow['direction'],
                workflowTitle: this.state.workflow['workflowTitle'],
                channelId: this.state.workflow['channelId'] || 'placeholder',
                extinfo: this.state.workflow['extinfo']
            })
            this.debug && console.log('[onNext]', workflow)
            let validation = validateWorkflow(workflow, this.props.uid, true)
            let isValid = validation['outcome']
            const client = this.state.workflow['direction'] === 'INFLOW' ? this.state.trigger['client'] : this.state.action['client']
            const onNextHandler = client && clientContext[client]['onNext']
            if(typeof onNextHandler === 'function' && isValid){
                onNextHandler({workflow: workflow, userId: this.props.uid})
                .then(res => {
                    validation = res
                    isValid = validation['outcome']

                    // Move to action
                    this.setState({
                        ...this.state,
                        workflow: workflow,
                        section: isValid ? 'ACTION' : 'TRIGGER',
                        error: validation['errors'],
                        spinner: null
                    })
                })
            } else {
                console.log('[MOVE TO THE NEXT]', isValid)
                // Move to action
                this.setState({
                    ...this.state,
                    workflow: workflow,
                    section: isValid ? 'ACTION' : 'TRIGGER',
                    error: validation['errors'],
                    spinner: null
                })
            }
        },500)
        
    }

    onSubmit = (callback) => {
        this.setState({ ...this.state, spinner: 'SUBMIT'})
        setTimeout(() => {
            // Validation
            const workflow = new ClientWorkflow({
                workflowId: this.state.workflow['workflowId'],
                userId: this.props.uid,
                trigger: this.state.trigger,
                action: this.state.action,
                direction: this.state.workflow['direction'],
                workflowTitle: this.state.workflow['workflowTitle'],
                channelId: this.state.workflow['channelId'] || 'placeholder',
                extinfo: this.state.workflow['extinfo']
            })
            this.debug && console.log('[onSubmit]', workflow)
            const validation = validateWorkflow(workflow, this.props.uid)
            const isValid = validation['outcome']
            typeof callback === 'function' && callback(isValid)
            if(isValid){
                this.setState({...this.state, workflow: validation['workflow'], section: 'TEST-TRIGGER', spinner: null})         
            } else {
                this.setState({
                    ...this.state,
                    error: validation['errors'],
                    spinner: null
                })
            }
        }, 500)
    }

    onCreate = (callback) => {
        // Validation
        const workflow = new ClientWorkflow({
            workflowId: this.state.workflow['workflowId'],
            userId: this.props.uid,
            trigger: this.state.trigger,
            action: this.state.action,
            direction: this.state.workflow['direction'],
            workflowTitle: this.state.workflow['workflowTitle'],
            channelId: this.state.workflow['channelId'] || 'placeholder',
            extinfo: this.state.workflow['extinfo']
        })
        this.debug && console.log('[onCreate]', workflow)
        const validation = validateWorkflow(workflow, this.props.uid)
        const isValid = validation['outcome']
        typeof callback === 'function' && callback(isValid)

        if(this.state.workflow['workflowId']){
            this.props.updateWorkflow(validation['workflow'], this.props.workflows, this.props.data, this.props.setScreen('DASHBOARD'))
        } else {
            this.props.createWorkflow(validation['workflow'], this.props.workflows, this.props.setScreen('DASHBOARD'))
        }
    }

    onBack = () => {
        if(this.state.section === 'TEST-TRIGGER'){
            this.setState({...this.state, section: 'ACTION'})
        } else if (['TRIGGER', 'ACTION'].includes(this.state.section)){
            // Return to dashboard
            this.props.setScreen('DASHBOARD')
        }
    }

    changeDirection = () => {
        const workflow = new ClientWorkflow({ 
            direction: this.state.workflow['direction'] === 'INFLOW' ? 'OUTFLOW' : 'INFLOW', 
        })
        console.log('[switch]', workflow)
        this.setState({section: 'TRIGGER', workflow: workflow, trigger: workflow['trigger'], action: workflow['action'], error: { trigger: { ext: {} }, action: { ext: {} } } })
    }

    render() {
        let content;
        if(this.state.section === 'TEST-TRIGGER') {
            content = <TriggerScreen state={this.state} onSubmit={this.onCreate}/>
        } else if (this.state.workflow['direction'] === 'INFLOW') {
            content = <InflowScreen state={this.state} onSelect={(state) => this.setState({...state}, () => this.debug && console.log(state))} onSubmit={this.onSubmit} onNext={this.onNext}/>
        } else if (this.state.workflow['direction'] === 'OUTFLOW') {
            content = <OutflowScreen state={this.state} onSelect={(state) => this.setState({...state})} onSubmit={this.onSubmit} onNext={this.onNext}/>
        }
        
        return(
            <Container>
                <div className={classes.Header}>
                    <Button icon={<FaChevronLeft style={{margin: '0 0.5rem 0 0'}}/>} styles={this.backStyle} 
                        onSelect={this.state.section !== 'TRIGGER' ? this.onBack : !this.state.workflow['workflowId'] ? this.onBack : null} 
                        contextMenu={this.state.workflow['workflowId'] && this.state.section === 'TRIGGER' && 
                        <DeleteDialogue 
                            warningText='Are you sure?' subtitle='Any changes made will not be saved' 
                            submitText='Confirm'
                            onDelete={this.onBack}
                            styles={{border: '1px solid var(--primary-accent-color)', boxShadow: 'var(--box-shadow)', maxWidth: '12rem'}}/>}
                        text={['TRIGGER', 'ACTION'].includes(this.state.section) ? 'Back to dashboard'
                            : this.state.section === 'TEST-TRIGGER' ? 'Back to edit'
                            : 'Back'} 
                        />
                    <TitleInput value={this.state.workflow.workflowTitle} key={this.state.workflow.workflowTitle}
                        // onSubmit={(title => console.log('[Editor.js]', title))}
                        onSubmit={(title) => this.setState({...this.state, workflow: {...this.state.workflow, workflowTitle: title}})}
                        />
                </div>

                <div className={classes.Body}>
                    {this.state.section !== 'TEST-TRIGGER' &&
                    <div className={classes.Title} onClick={this.changeDirection}>
                        <div>{this.state.workflow['direction'] === 'INFLOW' ? 'Inflow' : 'Outflow'}</div>
                        <FaExchangeAlt style={{transform: this.state.type === 'OUTFLOW' && 'scaleX(-1)'}}/>
                    </div>}
                    {/* <AnimateSharedLayout>{content}</AnimateSharedLayout> */}
                    <Animation key={this.state.workflow['direction']} duration={0.5}
                        animation={this.state.workflow['direction'] === 'INFLOW' ? 'right' : 'left'}>
                        {content}
                    </Animation>

                </div>
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        workflows: state.integration.workflows,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        createWorkflow: (workflow, data, callback) => dispatch(actionCreators.createWorkflow(workflow, data, callback)),
        updateWorkflow: (workflow, workflows, data, callback) => dispatch(actionCreators.updateWorkflow(workflow, workflows, data, callback)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Editor);